import type { ApiInvoice } from '#/api/invoice/types/ApiInvoice';
import type { ApiInvoiceId, ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  invoice: ApiInvoice;
  org: { id: ApiOrgId; name: string };
};

function mapResponse(response: ApiResponse): {
  invoice: ApiInvoice;
  org: { id: ApiOrgId; name: string };
} {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId, invoiceId: ApiInvoiceId) =>
    `/data/orgdashboard/${orgId}/invoices/${invoiceId}`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchInvoice =
  endpoint.createIsomorphicFetchFn();

export const orgDashboardApiClientFetchInvoice = endpoint.createClientFetchFn();
